import glamorous from "glamorous";

const Section = glamorous.div(({ theme, glam = {} }) => {
  // layout: left - image first; right - image last
  let mobileFlexDirection = "row";
  const { layout } = glam;
  switch (layout) {
    case "left":
      mobileFlexDirection = "column-reverse";
      break;
    case "right":
      mobileFlexDirection = "column";
      break;
    default: mobileFlexDirection = "row";
  }
  return {
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    padding: "4.5rem 1.0875rem",
    // exclude last child assuming it is a funnel
    ":nth-child(even):not(:last-child)": {
      background: theme.main.colors.light
    },
    [theme.main.mediaQueries.mobile]: {
      flexDirection: mobileFlexDirection,
      textAlign: layout
    }
  };
});

export default Section;



// WEBPACK FOOTER //
// ./src/components/Section/index.js